import { render, staticRenderFns } from "./iosbuy.vue?vue&type=template&id=55b606de&scoped=true"
import script from "./iosbuy.vue?vue&type=script&lang=js"
export * from "./iosbuy.vue?vue&type=script&lang=js"
import style0 from "./iosbuy.vue?vue&type=style&index=0&id=55b606de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b606de",
  null
  
)

export default component.exports